
import HeaderTitulo from "../../components/header-titulo";
import ArquivoEnviarRequest from "../../classes/AditivoEnviarRequest";
import AditivoService from "../../services/aditivoService";
// import { saveAs } from "file-saver";

export default {
  name: "comprovacaoNaoRural",
  props: ["propostaResponse"],
  components: { HeaderTitulo },
  data () {
    return {
      proposta: null,
      enquadramento: null,
      arquivo: null,
      arquivo1: null,
      arquivoEnviarRequest: new ArquivoEnviarRequest(),
      arquivoEnviarRequest1: new ArquivoEnviarRequest(),
      isLoadingUpload: false,
      radioValue: false,
      checkboxValue: false,
      faturamento1: 0.00,
      faturamento2: 0.00,
    };
  },
  mounted () {
    this.init();
  },
  watch: {},
  computed: {},
  methods: {
    init () {
      this.proposta = this.propostaResponse;
    },
    validacaoFormulario: function () {

      if (parseFloat(this.faturamento1) <= parseFloat(this.faturamento2)) {
        this.$b.nWarning(
          "Os faturamento 2021 informado não demonstra redução comparado ao mesmo período de 2020. Desenquadrado."
        );
        return false;
      }

      if (this.arquivo == null && this.proposta.uploadComprovacao) {
        this.$b.nWarning("É necessário efetuar upload da declaracao de faturamento 2020");
        return false;
      }

      if (this.arquivo !== null && this.arquivo.size > 1093956 && this.proposta.uploadComprovacao) {
        this.$b.nWarning("Arquivo vinculado nao pode ser maior que 1MB");
        return false;
      }

      if (this.arquivo1 == null && this.proposta.uploadComprovacao) {
        this.$b.nWarning("É necessário efetuar upload da declaracao de faturamento 2021");
        return false;
      }

      if (this.arquivo1 !== null && this.arquivo1.size > 1093956 && this.proposta.uploadComprovacao) {
        this.$b.nWarning("Arquivo vinculado nao pode ser maior que 1MB");
        return false;
      }

      if (this.checkboxValue == false) {
        this.$b.nWarning(
          "É necessário assinalar a declaração para prosseguir."
        );
        return false;
      }
      return true;
    },
    uploadArquivo () {
      if (this.validacaoFormulario() === false) {
        return
      }
      this.$q.loading.show()
      try {
        if (this.arquivo && this.proposta.uploadComprovacao) {
          this.toBase64(this.arquivo).then((res) => {
            this.arquivoEnviarRequest.base64 = res;
            this.arquivoEnviarRequest.idPropostaRepactuacao = this.proposta.idPropostaRepactuacao
            this.arquivoEnviarRequest.tipo = this.getTipoArquivo(this.arquivo);
          });
        } else {
          this.arquivoEnviarRequest = undefined
        }
        if (this.arquivo1 && this.proposta.uploadComprovacao) {
          this.toBase64(this.arquivo1).then((res) => {
            this.arquivoEnviarRequest1.base64 = res;
            this.arquivoEnviarRequest1.idPropostaRepactuacao = this.proposta.idPropostaRepactuacao
            this.arquivoEnviarRequest1.tipo = this.getTipoArquivo(this.arquivo1);
            this.sendFileToServer();
          });
        } else {
          this.arquivoEnviarRequest1 = undefined
          this.sendFileToServer();
        }
      } catch (err) {
        this.$b.nError('Erro ao enviar Dados.')
      } finally {
        this.$q.loading.hide()
      }
    },
    sendFileToServer () {
      this.isLoadingUpload = true;
      const request = {
        idPropostaRepactuacao: this.proposta.idPropostaRepactuacao,
        enquadramento: null,
        faturamento1: this.faturamento1,
        faturamento2: this.faturamento2,
      };

      AditivoService.uploadComprovacao(
        request,
        this.arquivoEnviarRequest,
        this.arquivoEnviarRequest1,
        this.proposta.idPropostaRepactuacao,
        this.proposta.chave
      )
        .then((res) => {
          if (res.data.code === 99) {
            this.$b.nError(`${res.data.message}`);
            return;
          }
          this.$router.push({
            name: "aditivo",
            params: { propostaResponse: this.proposta },
          });
        })
        .catch((err) => {
          this.$b.nError(`${err.data.message}`);
        })
        .finally(() => (this.isLoadingUpload = false));
    },
    /**
     * Converte File para Base64
     * @param {File} file
     * @returns {Promise<String>}
     */
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    /**
     *
     * @param {File} file
     */
    getTipoArquivo (file) {
      return file.type === "application/pdf" ? "PDF" : "JPG";
    }
  },
  beforeMount () {
    this.init();
  },
};
